import styled from 'styled-components'

export const BreadcrumbOuter = styled.div<{
  $breadcrumbTheme?: string
  $pageType?: string
  $useCase?: string
}>`
  ${({ theme, $breadcrumbTheme, $pageType, $useCase }: any) => {
    let linkStyles = ''
    let iconStyles = ''
    let homeIconStyles = ''
    let nextPageStyles = ''
    let currentPageStyles = ''
    let thankYouStyles = ''

    if ($useCase === 'Full width hero') {
      nextPageStyles = `
        justify-content: flex-end;
      `
      currentPageStyles = `
        display: none;
      `
    }

    if ($breadcrumbTheme === 'light') {
      linkStyles = `
        color: ${theme.webMktNewPalette.content.dark.tertiary};;

        &--Current {
          color: ${theme.webMktNewPalette.alphaBlack[30]};
          &.FwCurrentPage{
            ${
              $useCase === 'Full width hero'
                ? `color: ${theme.webMktNewPalette.content.dark.tertiary};`
                : ''
            }
          }
        }

        &:not(.Breadcrumbs__Link--Current) {
          &:hover {
            color: ${theme.webMktNewPalette.action.light.primary}
          }
        }
      `

      iconStyles = `
        svg {
          #icon,
          #ArrowPath {
            fill: ${theme.webMktNewPalette.content.dark.tertiary};;
          }
        }
      `

      homeIconStyles = `
        &:hover {
          svg {
            #icon {
              fill: ${theme.webMktPalette.icon.blueLight};
            }
          }
        }
      `
    }

    if ($breadcrumbTheme === 'dark' || $breadcrumbTheme === 'orange') {
      linkStyles = `
        color: ${theme.webMktNewPalette.white};

        &--Current {
          color:${theme.webMktNewPalette.alphaWhite[30]};
          &.FwCurrentPage{
            ${$useCase === 'Full width hero' ? `color:  ${theme.webMktNewPalette.white}` : ''}
          }
        }

        &:not(.Breadcrumbs__Link--Current) {
          &:hover {
            color: ${theme.webMktPalette.text.actionDark};
          }
        }
      `

      iconStyles = `
        svg {
          #icon,
          #ArrowPath {
            fill: ${theme.webMktNewPalette.white};
          }
        }
      `

      homeIconStyles = `
        &:hover {
          svg {
            #icon {
              fill: ${theme.webMktPalette.icon.blueDark};
            }
          }
        }
      `
    }

    if ($pageType === 'thankYou') {
      thankYouStyles = `
        display: none;

        ${theme.breakpoints.down('sm')} {
          display: flex;
        }

        ${theme.breakpoints.down('xs')} {
          display: flex;
        }
      `
    }

    return `
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;
      z-index: 1;
      justify-content: space-between;

      ${theme.breakpoints.down('xs')} {
        ${$useCase === 'Full width hero' ? nextPageStyles : ''}
      }

      .Breadcrumbs__Icon {
        &:not(.Breadcrumbs__Home-Icon) {
          margin: 0 8px;
        }

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        ${iconStyles};
      }

      .Breadcrumbs__NextPage,
      .Breadcrumbs__CurrentPage {
        display: flex;
        align-items: center;
      }

      .Breadcrumbs__NextPage{
        .Breadcrumbs__Icon {
          margin-left: 24px;
          margin-right: 24px;
        }
        .nextPageLink{
          display: flex;
          align-items: center;
          ${iconStyles}
          .Breadcrumbs__Link{
            font-size:14px;
          }
          svg{
            width: 18px;
            height: 20px;
            margin-left: 10px;            
          }
        }
      }

      .Breadcrumbs__CurrentPage {
        ${theme.breakpoints.down('xs')} {
          ${$useCase === 'Full width hero' ? currentPageStyles : ''}
        }
      }      

      .Breadcrumbs__Home-Icon {
        display: flex;
        width: 16px;
        height: 16px;
        ${homeIconStyles};
      }

      .Breadcrumbs__Link {
        font-size: 12px;
        letter-spacing: 0px;
        line-height: 16px;
        margin-top: 5px;
        margin-bottom: 5px;
        display: inline-block;

        &:not(.Breadcrumbs__Link--Current) {
          cursor: pointer;
        }

        transition: 0.1s all cubic-bezier(0.4, 0.0, 0.2, 1);
        ${linkStyles};

        &:not(.Breadcrumbs__Link--Current) {
          &:hover {
            text-decoration: underline;
          }
        }
      }
      
      ${thankYouStyles};
    `
  }}
`
